import { BACKEND_URL } from "./DataSender";

var instance = null;

export default class DataSender {
  constructor() {
    if (instance) return instance;
    instance = this;
  }

  async errorHandle(response) {
    if (!response.ok) {
      throw new Error(await response.text());
    }
    return response;
  }

  getHeader(method, data) {
    return {
      method,
      mode: "cors",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Cache: "no-cache",
      },
      credentials: "include",
      body: JSON.stringify(data),
    };
  }

  adminLogin(data) {
    return fetch(`${BACKEND_URL}/doLogin`, this.getHeader("POST", data)).then(
      this.errorHandle
    );
  }

  // 훈련 결과 관련

  getTrain(type) {
    return fetch(
      `${BACKEND_URL}/admin/train/${type}`,
      this.getHeader("GET")
    ).then(this.errorHandle);
  }

  getTrainCount(type) {
    return fetch(
      `${BACKEND_URL}/admin/train_count/${type}`,
      this.getHeader("GET")
    ).then(this.errorHandle);
  }

  deleteTrain(data) {
    return fetch(
      `${BACKEND_URL}/admin/train`,
      this.getHeader("DELETE", data)
    ).then(this.errorHandle);
  }

  updateTrain(data) {
    return fetch(
      `${BACKEND_URL}/admin/train`,
      this.getHeader("PUT", data)
    ).then(this.errorHandle);
  }

  // 병사 관리 관련

  getSoldier() {
    return fetch(`${BACKEND_URL}/admin/solider`, this.getHeader("GET")).then(
      this.errorHandle
    );
  }

  getSoldierCount() {
    return fetch(`${BACKEND_URL}/admin/count`, this.getHeader("GET")).then(
      this.errorHandle
    );
  }

  deleteSoldier(data) {
    return fetch(
      `${BACKEND_URL}/admin/solider`,
      this.getHeader("DELETE", data)
    ).then(this.errorHandle);
  }

  updateSoldier(data) {
    return fetch(
      `${BACKEND_URL}/admin/solider`,
      this.getHeader("PUT", data)
    ).then(this.errorHandle);
  }

  // 건강 체크 관련

  getHealth() {
    return fetch(`${BACKEND_URL}/admin/health`, this.getHeader("GET")).then(
      this.errorHandle
    );
  }

  getHealthCount() {
    return fetch(
      `${BACKEND_URL}/admin/health_count`,
      this.getHeader("GET")
    ).then(this.errorHandle);
  }

  deleteHealth(data) {
    return fetch(
      `${BACKEND_URL}/admin/health`,
      this.getHeader("DELETE", data)
    ).then(this.errorHandle);
  }

  updateHealth(data) {
    return fetch(
      `${BACKEND_URL}/admin/health`,
      this.getHeader("PUT", data)
    ).then(this.errorHandle);
  }

  checkPermission() {
    return fetch(`${BACKEND_URL}/checkLogin`, this.getHeader("POST")).then(
      this.errorHandle
    );
  }

  logout() {
    return fetch(`${BACKEND_URL}/logout`, this.getHeader("POST")).then(
      this.errorHandle
    );
  }
}
